<app-global-snipper [spinnerText]="spinnerText" *ngIf="loadingVisible"></app-global-snipper>
<div class="main-content-container">
	<div class="side-nav" [ngClass]="isCollaps ? ' hideSidebar': 'showSidebar'">
		<app-side-nav (isToggle)="isToggleSidnavbar($event)" [isAuthenticated]="isAuthenticated"></app-side-nav>
	</div>
	<div class="main-app" [ngClass]="isCollaps ? 'main-show ': ''">
		<div>
			<app-header [userDetails]="userDetails" (logOutShow)="logoutShow($event)"></app-header>
		</div>
		<div class="main-router-outlet">
			<div class="logout-main" *ngIf="logoutpopover">
				<span class="logout-btn" (click)="logout()">logout</span>
			</div>
			<router-outlet></router-outlet>
		</div>
	</div>
</div>